<template>
    <span class="SelectEditor">
        <span v-if="CheckPermission(ViewPermissionRequirement)">
            {{ OldValueText }}
            <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode && CheckPermission(EditPermission)" v-on:click="ShowEditModal()" class="pointer" />
            <b-modal ref="component-modal" v-bind:title="ModalTitle" @shown="HandleShown()" hide-footer>
                <b-container>
                    <b-form @submit="Save">
                        <b-row>
                            <b-col>
                                <div class="form-group">
                                    <label>Old Value:</label>
                                    <input class="form-control" v-model="OldValueText" disabled />
                                    <label>New Value:</label>
                                    <select v-if="OptionsGroupName == null" class="form-control" v-model="NewValue" ref="showfocus" v-bind:required="Required">
                                        <option v-for="option in Options" v-bind:value="option.value">
                                            {{ option.text }}
                                        </option>
                                    </select>
                                    <SelectFromEndpoint v-else options-group-name="OptionsGroupName" v-model="NewValue" ref="showfocus" v-bind:required="Required" />
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="Cancel()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="success" type="submit">
                                    SAVE
                                </b-button>
                            </div>

                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>
        </span>
        <span v-else>
            PRIVATE
        </span>
    </span>

</template>

<script>
    //import icons
    //import { library } from '@fortawesome/fontawesome-svg-core';
    //import { faEdit } from '@fortawesome/free-solid-svg-icons';
    //library.add(faEdit);

    import { EventBus } from '../../../services/event-bus.js';
    import SelectFromEndpoint from '../CustomInputElements/SelectFromEndpoint.vue';

    export default {
        props: [
            "OldValue",
            "OldValueText",
            "PropertyName",
            "RecordId",
            "RecordIdName",
            "EditMode",
            "DataLabel",
            "UpdateMethod",
            "Required",
            "Options",
            "EditPermission",
            "ViewPermissionRequirement",
            "ChartId",
            "HttpMethod",
            "AdditionalPayload",
            "ChartUpdateOnly"
        ],
        data: function () {
            return {
                NewValue: {}
            };
        },
        methods: {
            ShowEditModal() {
                this.NewValue = this.OldValue;
                this.$refs['component-modal'].show();
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            Save(e) {
                e.preventDefault();
                let payload = { [this.RecordIdName === undefined ? "Id" : this.RecordIdName]: this.RecordId, [this.PropertyName]: this.NewValue };
                if (this.AdditionalPayload != null) {
                    payload = { ...payload, ...this.AdditionalPayload };
                }
                this.$MasterAPI.ExecuteRequest(this.HttpMethod == null ? "POST" : this.HttpMethod, this.UpdateMethod, payload, this.SaveSuccess, () => { }, true);
            },
            SaveSuccess(response) {
                this.OldValue = this.NewValue;
                this.$refs['component-modal'].hide();
                //Perform Global Updates
                if (this.ChartUpdateOnly) {
                    this.$GlobalUpdate.ExecuteChartUpdate(this.ChartId);
                } else {
                    this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
                }
                
            },
            HandleShown() {
                this.$refs.showfocus.focus();
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            }
        },
        components: {
            SelectFromEndpoint
        },
        computed: {
            ModalTitle: function () {
                return "Editing " + this.DataLabel;
            }
        }
    }
</script>

<style scoped>
</style>